const REFRESH_BATCH_DELAY_MS = 250
const MIN_REFRESH_INTERVAL_MS = 1000
const queues = new WeakMap()

// One queue per cached query, shared by every mounted view. Events arriving
// during a fetch stay pending so its response cannot swallow a newer change.
export const scheduleMapQueryRefresh = (queryClient, filters) => {
  queryClient.invalidateQueries({ ...filters, refetchType: 'none' })
  queryClient
    .getQueryCache()
    .findAll(filters)
    .forEach(query => {
      if (!query.isActive() || query.isDisabled()) return

      let queue = queues.get(query)
      if (!queue) {
        queue = {
          pending: false,
          running: false,
          timer: null,
          lastStartedAt: 0
        }
        queues.set(query, queue)
      }
      queue.pending = true

      const schedule = () => {
        if (queue.running || queue.timer !== null) return
        const delay = Math.max(
          REFRESH_BATCH_DELAY_MS,
          queue.lastStartedAt + MIN_REFRESH_INTERVAL_MS - Date.now()
        )
        queue.timer = setTimeout(async () => {
          queue.timer = null
          if (!query.isActive() || query.isDisabled()) {
            queue.pending = false
            return
          }

          queue.running = true
          // Joining an existing request is safe, but it still needs a trailing
          // fetch: that request may have read the server before this event.
          if (query.state.fetchStatus !== 'fetching') {
            queue.pending = false
            queue.lastStartedAt = Date.now()
          }
          try {
            await queryClient.refetchQueries(
              { queryKey: query.queryKey, exact: true, type: 'active' },
              { cancelRefetch: false }
            )
          } finally {
            queue.running = false
            if (queue.pending) schedule()
          }
        }, delay)
      }
      schedule()
    })
}
